document.addEventListener("DOMContentLoaded", function () {
  // Prevent tooltip icon clicks inside <summary> from toggling the disclosure
  document.querySelectorAll('summary .cart-info-tooltip__icon').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  const cartNote = document.querySelector('#cart-note');

  if (cartNote) {
    if (localStorage.getItem('cartNoteValue')) {
      cartNote.value = localStorage.getItem('cartNoteValue');
    }
    cartNote.addEventListener('input', function () {
      localStorage.setItem('cartNoteValue', cartNote.value);
    });
  }

  function attachGiftNoteHandler() {
    const giftNote = document.querySelector('#gift-note');
    if (giftNote) {
      if (localStorage.getItem('giftNoteValue')) {
        giftNote.value = localStorage.getItem('giftNoteValue');
      }
      giftNote.addEventListener('input', function () {
        localStorage.setItem('giftNoteValue', giftNote.value);
      });
    }
  }

  attachGiftNoteHandler();

  // Auto-check the gift checkbox when the gift note popup opens in the cart drawer
  function attachGiftDisclosureHandler() {
    const giftDisclosure = document.getElementById('gift-note-disclosure-drawer');
    if (giftDisclosure && !giftDisclosure._giftHandlerAttached) {
      giftDisclosure._giftHandlerAttached = true;
      giftDisclosure.addEventListener('toggle', function () {
        if (giftDisclosure.open) {
          const checkbox = giftDisclosure.querySelector('#gift-checkbox');
          if (checkbox && !checkbox.checked) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }
  }

  attachGiftDisclosureHandler();

  // Close other open disclosures when one opens (prevent overlapping popups)
  function attachExclusiveDisclosures() {
    var summaryEl = document.querySelector('.cart-drawer__summary');
    if (!summaryEl || summaryEl._exclusiveDisclosures) return;
    summaryEl._exclusiveDisclosures = true;
    summaryEl.addEventListener('toggle', function (e) {
      if (!e.target.open || e.target.tagName !== 'DETAILS') return;
      summaryEl.querySelectorAll('details[open]').forEach(function (d) {
        if (d !== e.target) d.open = false;
      });
    }, true);
  }

  attachExclusiveDisclosures();

  // ── Packing Preference Dropdown ──────────────────────────────────
  function closeAllPackingPrefs() {
    document.querySelectorAll('.packing-pref.is-open').forEach(function (p) {
      p.classList.remove('is-open');
      var panel  = p.querySelector('.packing-pref__panel');
      var toggle = p.querySelector('.packing-pref__toggle');
      if (panel)  panel.style.display = 'none';
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function applyPackingPref(pref, value) {
    var input   = pref.querySelector('input[type="hidden"]');
    var valSpan = pref.querySelector('.packing-pref__value');
    var options = pref.querySelectorAll('.packing-pref__option');
    if (input)   input.value = value;
    if (valSpan) valSpan.textContent = value;
    options.forEach(function (o) {
      o.classList.toggle('is-selected', o.getAttribute('data-value') === value);
    });
    pref._selectedValue = value;
  }

  function resetPackingPref(pref) {
    var input     = pref.querySelector('input[type="hidden"]');
    var valSpan   = pref.querySelector('.packing-pref__value');
    var options   = pref.querySelectorAll('.packing-pref__option');
    var panel     = pref.querySelector('.packing-pref__panel');
    var toggle    = pref.querySelector('.packing-pref__toggle');
    var label     = pref.dataset.label || '';
    if (valSpan)  valSpan.textContent = label;
    if (input)    input.value = '';
    pref._selectedValue = null;
    options.forEach(function (o) {
      o.classList.remove('is-selected');
      o.style.display = '';
    });
    pref.classList.add('is-open');
    if (panel)  panel.style.display = '';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function attachPackingPrefHandler() {
    document.querySelectorAll('.packing-pref').forEach(function (pref) {
      if (pref._packingPrefAttached) return;
      pref._packingPrefAttached = true;

      var toggle  = pref.querySelector('.packing-pref__toggle');
      var panel   = pref.querySelector('.packing-pref__panel');
      var options = pref.querySelectorAll('.packing-pref__option');

      // Store the default label text for reset
      var valSpan = pref.querySelector('.packing-pref__value');
      if (valSpan) pref.dataset.label = valSpan.textContent;

      pref._selectedValue = null;

      // Toggle open / close
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = pref.classList.contains('is-open');
        closeAllPackingPrefs();
        if (!isOpen) {
          pref.classList.add('is-open');
          panel.style.display = '';
          toggle.setAttribute('aria-expanded', 'true');
          // If a value is already selected, hide the selected option
          if (pref._selectedValue) {
            options.forEach(function (o) {
              o.style.display = o.getAttribute('data-value') === pref._selectedValue ? 'none' : '';
            });
          } else {
            options.forEach(function (o) { o.style.display = ''; });
          }
        }
      });

      // Select an option → apply, collapse, hide selected in future opens
      options.forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.stopPropagation();
          applyPackingPref(pref, option.getAttribute('data-value'));
          pref.classList.remove('is-open');
          panel.style.display = 'none';
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    });

    if (!document._packingPrefOutsideClick) {
      document._packingPrefOutsideClick = true;
      document.addEventListener('click', closeAllPackingPrefs);
    }
  }

  // Reset packing dropdown when cart drawer closes
  if (!document._packingDrawerCloseListener) {
    document._packingDrawerCloseListener = true;
    var cartDrawerEl = document.getElementById('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.addEventListener('on:cart-drawer:after-close', function () {
        document.querySelectorAll('.packing-pref').forEach(resetPackingPref);
      });
    } else {
      // Drawer may not exist yet — wait for it
      var drawerObserver = new MutationObserver(function () {
        var el = document.getElementById('cart-drawer');
        if (el) {
          drawerObserver.disconnect();
          el.addEventListener('on:cart-drawer:after-close', function () {
            document.querySelectorAll('.packing-pref').forEach(resetPackingPref);
          });
        }
      });
      drawerObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  attachPackingPrefHandler();

  const observer = new MutationObserver(function () {
    attachGiftNoteHandler();
    attachGiftDisclosureHandler();
    attachPackingPrefHandler();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelector('.check-out-btn')?.addEventListener('click', function () {
    localStorage.removeItem('cartNoteValue');
    localStorage.removeItem('giftNoteValue');
  });
});
